import styled from 'styled-components';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 50px;
  width: 100%;
`;

const Logo = styled.img`
  max-width: 250px;
`;

const Message = styled.p`
  color: #192c47;
  font-size: 14pt;
  margin-bottom: 40px;
  margin-top: 40px;
  text-align: center;
`;

const ReportFeedback = styled.a`
  cursor: pointer;
`;

export {
  Container, Logo, Message, ReportFeedback,
};
